import { useTranslation } from 'react-i18next'
import { ChartOptions } from 'chart.js'
import { Card, CardContent, Typography } from '@mui/material'
import { DateRange, RuuviTagMovement } from '../types'
import RuuviTagMovementChart from './RuuviTagMovementChart'

interface RuuviTagMovementCountChartProps {
  movements: RuuviTagMovement[]
  dateRange: DateRange
  loading?: boolean
}

export default function RuuviTagMovementCountChart({
  movements,
  dateRange,
  loading = false
}: RuuviTagMovementCountChartProps) {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  /**
   * The chart options.
   */
  const options: ChartOptions = {
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: true
        }
      }
    }
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h4" sx={{ mb: 6 }}>
          {t('movement')}
        </Typography>

        <RuuviTagMovementChart
          movements={movements}
          dateRange={dateRange}
          options={options}
          loading={loading}
        />
      </CardContent>
    </Card>
  )
}
